import React, { useEffect, useState } from 'react';
import { formatMoney, getData, insertData } from '../../Tools/helpers';
import FinancialSummaryFranchise from './FinancialSummaryFranchise';
import PaymentModal from './ModalPayment';
import Button from '@mui/material/Button';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { pdf } from '@react-pdf/renderer';
import PDFEstadoCuenta from './PDFEstadoCuenta';

const ModalAccount = ({
  selectedMonth, 
  setSelectedMonth, 
  accountStatements, 
  selectedFranchise, 
  setShowAccountStatement, 
  universityID, 
  setUpdateInvoiceData, 
  getAccountStatements, 
  getGlobalSummary,
  creditBalanceFranchis,
  selectedInvoice
}) =>{

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isPaymentReinscription, setIsPaymentReinscription] = useState(false);
  const [payments, setPayments] = useState([]);
  const [students, setStudents] = useState([]);
  const reinscriptionCost = selectedFranchise?.cost_university?.cost_reinscription ?? 500;

  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const getPayments = async (university_id) => {
    const route = `Franchise-Payment/${university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setPayments(send.data);
    }
  };

  const getStudents = async (university_id) => {
    const route = `Franchise-Student/${university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setStudents(send.data);
    }
  };

  const handlePaymentSubmit = async (paymentData) => {
    
    const formData = new FormData();
    formData.append('amount', paymentData.amount);
    formData.append('credit_balance', paymentData.credit_balance);
    formData.append('credit_balance_amount', paymentData.credit_balance ? creditBalanceFranchis : 0);
    formData.append('date', paymentData.date ?? '');
    formData.append('reference', paymentData.reference ?? '');
    formData.append('type', paymentData.type);
    formData.append('module', paymentData.module);
    formData.append('remaining', paymentData.remaining);
    formData.append('evidence', paymentData.proof ?? '');
    formData.append('university_id', universityID);
    formData.append('invoice_id', selectedInvoice);

    const send = await insertData('Franchise-Payment', formData);
    if (send.code === 201) {
      setMessage({
        status: true,
        message: "Se ha registrado el pago correctamente",
        label: "success",
      });
      getAccountStatements(universityID);
      getPayments(universityID);
      getGlobalSummary();
      setTimeout(()=>{
        setShowPaymentModal(false);
      }, 1500)
      return;
    }

    if(send.status === "error"){
      setMessage({
        status: true,
        message: send.message,
        label: "error",
      });
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo y no se realizó el pago",
      label: "error",
    });

  };

  useEffect(()=>{
    getPayments(universityID);
    getStudents(universityID);
  },[selectedFranchise])

  const handleDownloadPDF = async () => {
    const blob = await pdf(
      <PDFEstadoCuenta
        selectedMonth={selectedMonth}
        accountStatements={accountStatements}
        selectedFranchise={selectedFranchise}
        students={students}
        reinscriptionCost={reinscriptionCost}
      />
    ).toBlob();
    const url  = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href     = url;
    link.download = `estado-cuenta-${selectedFranchise?.short_name ?? 'franquicia'}-${selectedMonth}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] overflow-auto">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">
            CUOTA MES DE {selectedMonth.toUpperCase()} - {selectedFranchise.short_name}
          </h3>
          <button 
            onClick={() => setShowAccountStatement(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        <FinancialSummaryFranchise
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          accountStatements={accountStatements}
          payments={payments}
          getPayments={getPayments}
          showActions={true}
          setUpdateInvoiceData={setUpdateInvoiceData}
          students={students}
          selectedFranchise={selectedFranchise}
          reinscriptionCost={reinscriptionCost}
          universityID={universityID}
          getAccountStatements={getAccountStatements}
          onPayCuotas={() => { setIsPaymentReinscription(false); setShowPaymentModal(true); }}
          onPayReinscription={() => { setIsPaymentReinscription(true); setShowPaymentModal(true); }}
        />

        <div className="mt-6 flex justify-between items-center">
          <div>
          </div>
          <div className="flex space-x-3">
            <Button
              variant="outlined"
              startIcon={<PictureAsPdfIcon />}
              onClick={handleDownloadPDF}
              size="small"
            >
              Descargar PDF
            </Button>
            <button
              onClick={() => setShowAccountStatement(false)}
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    {showPaymentModal && (
        <PaymentModal
          selectedMonth={selectedMonth} 
          accountStatements={accountStatements} 
          onClose={() => setShowPaymentModal(false)}
          onPaymentSubmit={handlePaymentSubmit}
          creditBalanceFranchis={creditBalanceFranchis}
          message={message}
          isPaymentReinscription={isPaymentReinscription}
          reinscriptionTotal={students.filter(s => s.status === 'Activo').length * reinscriptionCost}
        />
      )}
  </div>
  )
}

export default ModalAccount